<error-component></error-component>
<upload-progress-component></upload-progress-component>
@if (vm?.form && vm?.card && vm?.i18nKeys) {
  <div class="box" #boxEl>
    @if (vm?.customStyle) {
      <link rel="stylesheet" [href]="vm.customStyle" type="text/css" />
    }
    @if (vm?.customFont) {
      <link rel="stylesheet" [href]="vm.customFont" />
    }
    <logo-component id="logoComponent" [showClose]="vm.showClose" [showHelp]="vm.helpButtonDisplayed" (helpRequested)="requestHelp()"></logo-component>
    <div class="jumpcontent">
      @if (vm?.form && vm?.card && vm?.i18nKeys) {
        @if (vm?.helpEnabled) {
          <div class="relay-card-wrapper" [ngClass]="vm.wrapperClass">
            <div class="relay-card-inner">
              <help-component [vm]="vm"></help-component>
            </div>
          </div>
          <help-actions [vm]="vm"></help-actions>
        } @else {
          <div [@fixedProgress]="vm.state" class="fixedSummary">
            <summary-component></summary-component>
          </div>
          <div [@cardsTop]="vm.state">
            <div class="relay-card-wrapper" [ngClass]="vm.wrapperClass">
              <div class="relay-card-inner" [class.showCard]="vm.card">
                @if (vm.card.type === 'csat') {
                  <question-group [form]="asFormGroup(vm?.form?.controls[vm.card.key])" [card]="vm.card">
                  </question-group>
                } @else {
                  <!-- once we have updated cards lib controls then we can useJuiControls to roll out -->
                  <crds-card
                    [form]="vm.form"
                    [card]="vm.card"
                    [i18ns]="vm?.i18nKeys"
                    deviceContext="mobile"
                    [useJuiControls]="false"
                  ></crds-card>
                }
              </div>
            </div>
            <div #actionsEl>
              <actions-component
                [readOnly]="vm.readOnly"
                [demo]="vm.demo"
                (actionClicked)="cardChanged()"
              ></actions-component>
            </div>
          </div>
        }
      }
    </div>
  </div>
  <ngx-spinner
    name="relaySpinner"
    bdColor="rgba(51, 51, 51, 0.8)"
    size="large"
    color="#ff8200"
    type="line-scale"
    [attr.data-qa]="'relaySpinner'"
    >
  </ngx-spinner>
}
